var r = {
  zIndex: 2e3,
  lockCount: 0,
  stack: [],
  find: function find(n) {
    return this.stack.filter(function (t) {
      return t.vm === n;
    })[0];
  },
  remove: function remove(n) {
    var t = this.find(n);
    if (t) {
      t.vm = null, t.overlay = null;
      var i = this.stack.indexOf(t);
      this.stack.splice(i, 1);
    }
  }
};
export { r as context };
